import React from 'react';
import { getChromeVersion, getIEVersion } from 'library/helpers';
import AuthService from 'library/authService/auth-service';
import LoginOptions from 'views/login/options';
import LoginSignIn from 'views/login/signin';
import { Icon } from 'antd';
import settings from 'settings';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBrowserWarning: false,
      signIn: {
        show: false,
        loading: false,
        error: null
      }
    };

    this.handleLoginOptionClick = this.handleLoginOptionClick.bind(this);
    this.handleSignInSubmitClick = this.handleSignInSubmitClick.bind(this);
    this.handleSignInShowOptionsClick = this.handleSignInShowOptionsClick.bind(this);
  }

  componentDidMount() {
    if (getChromeVersion() === -1) {
      const ieVersion = getIEVersion();
      if (ieVersion === -1 || ieVersion >= 8) {
        this.setState({ showBrowserWarning: true });
      }
    }
  }

  setSignInState(visible = false, loading = false, error = null) {
    this.setState({
      signIn: {
        show: visible,
        loading,
        error
      }
    });
  }

  UNSAFE_componentWillMount() {
    if (AuthService.isAuthenticated()) {
      // Redirect user to the Site Tenancy
      // selection page if authenticated.
      AuthService.redirectToTenancy();
    }
    else {
      // If not authenticated, check if the user
      // has selected a Login Option and process
      // accordingly. If the user had selected MSAL
      // login and had previously logged in without
      // logging out, we need to call the MSAL login
      // method to re-fetch the user's token.
      AuthService.checkLoginOption();
    }
  }

  handleLoginOptionClick(value) {
    switch (value) {
    case 'msal':
      AuthService.loginMsal();
      break;

    case 'jwt':
      this.setSignInState(true);
      break;

    default:
      break;
    }
  }

  handleSignInSubmitClick(values) {
    this.setSignInState(true, true);

    AuthService.loginJwt(values.username, values.password)
      .then(
        () => {
          this.setSignInState(true, false);
          AuthService.redirectToTenancy();
        },
        (error) => {
          this.setSignInState(true, false, error.nonFieldErrors[0]);
        }
      );
  }

  handleSignInShowOptionsClick() {
    this.setSignInState(false);
  }

  render() {
    const { showBrowserWarning, signIn } = this.state;

    return (
      <div className="bhp-login">
        <div className="bhp-modal bhp-open">
          <div className="bhp-modal-panel">
            {showBrowserWarning
            && (
              <div className="bhp-banner">
                <Icon type="chrome" />
                {' '}
                This site works better in Chrome
              </div>
            )}
            <LoginOptions visible={!signIn.show} onOptionClick={this.handleLoginOptionClick} />
            <LoginSignIn
              visible={signIn.show}
              loading={signIn.loading}
              error={signIn.error}
              onSubmitClick={this.handleSignInSubmitClick}
              onShowOptionsClick={this.handleSignInShowOptionsClick}
            />
          </div>
        </div>
        <div className="bhp-footer">
          Crew Rostering v{settings.APP_CONFIG.versionNo} &copy; BHP
        </div>
      </div>
    );
  }
}

export default Login;
